export enum GiftItemStatus {
  Published = 'published',
  Unpublished = 'unpublished',
  Archived = 'inactive',
}
export enum GiftItemType {
  Accommodation = 'Accommodation',
  AfternoonTea = 'Afternoon Tea',
  Brunch = 'Brunch',
  Complimentary = 'Complimentary',
  Course = 'Course',
  Dinner = 'Dinner',
  Experience = 'Experience',
  Gifts = 'Gifts',
  Golf = 'Golf',
  Lunch = 'Lunch',
  Monetary = 'Monetary',
  Other = 'Other',
  Restaurant = 'Restaurant',
  Spa = 'Spa',
  Treatment = 'Treatment',
}
export interface ITicketPrice {
  id: number
  name: string
  value: string
  status: GiftItemStatus
  quantitySold?: number
  enabledQuestionIds?: number[]
  questions?: ITicketQuestion[]
}
interface BaseGiftItem {
  id: number
  value: string
  name: string
  terms: string
  imageUrl: string
  imageFileId: number
  status: GiftItemStatus
  embedUrl: string
  order: number
  categoryIds: number[]
  showOverlay: boolean
  overlayImageUrl: string
  overlayImageFileId: number
}
export interface IGiftVoucher extends BaseGiftItem {
  type: string
  validity: number | null
  description: string
  details: string
  maxIndividuals: number
}
interface BaseSpecialGiftItem extends BaseGiftItem {
  showRemaining: boolean
  quantity: number | null
  maxPerOrder: number | null
  headerImageUrl: string
  headerImageFileId: number
  quantitySold: number
  publishDate: number
  unpublishDate: number
}
export interface ISpecialOffer extends BaseSpecialGiftItem {
  originalPrice: number | null
  restrictions: string
  startDate: number
  expiryDate: number
}
export interface ITicket extends BaseSpecialGiftItem {
  enabledQuestionIds?: number[]
  questions?: ITicketQuestion[]
  startInfo: string
  prices?: ITicketPrice[]
  originalId?: number
}

export interface IGiftItemResponse
  extends Partial<IGiftVoucher>,
    Partial<ISpecialOffer>,
    Partial<ITicket> {}

export type UnknownItem = IGiftVoucher | ISpecialOffer | ITicket

export interface IColorTheme {
  colourBodyText?: string
  colourHeaderText?: string
  colourHighlight?: string
  colourPageBackground?: string
  colourPriceText?: string
  colourTextOnBackground?: string
  colourTextOnHighlight?: string
  colourHeaderBackground?: string
  transparentIframe?: boolean
  fade?: string
  hover?: string
}

export interface IAddToBasket {
  addToBasket?: (
    giftItem: IGiftItemResponse,
    value: number,
    quantity: number,
    individuals: number,
  ) => void
}

export interface ITicketQuestion {
  id: number
  max?: number
  min?: number
  options?: string
  title: string
  type: QuestionType
  required?: boolean
  used?: boolean
}

export enum QuestionType {
  Text = 'text',
  Textarea = 'textarea',
  Checkbox = 'checkbox',
  Phone = 'phone',
  Radio = 'radio',
  Number = 'number',
  Date = 'date',
}

export type SelectedPrice = { id: number; count: number; value: string }
